// extracted by mini-css-extract-plugin
export var list = "index-module--list--MDHR1";
export var listItemSpacer = "index-module--list-item-spacer--Jt09n";